import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.dom-collections.iterator.js";
const utf8 = (s)=>new TextEncoder().encode(s);
const fmt = (n)=>Number(n.toFixed(4)).toString();
const concatBytes = (chunks)=>{
    const arrays = chunks.map((c)=>typeof c === 'string' ? utf8(c) : c);
    const total = arrays.reduce((sum, a)=>sum + a.length, 0);
    const out = new Uint8Array(total);
    let offset = 0;
    for (const arr of arrays){
        out.set(arr, offset);
        offset += arr.length;
    }
    return out;
};
const fitImageRectPt = (imgWidthPx, imgHeightPx, pageWidthPt, pageHeightPt)=>{
    const imgAspect = imgWidthPx / imgHeightPx;
    const pageAspect = pageWidthPt / pageHeightPt;
    if (imgAspect > pageAspect) {
        const widthPt = pageWidthPt;
        const heightPt = pageWidthPt / imgAspect;
        return {
            xPt: 0,
            yPt: (pageHeightPt - heightPt) / 2,
            widthPt,
            heightPt
        };
    }
    const heightPt = pageHeightPt;
    const widthPt = pageHeightPt * imgAspect;
    return {
        xPt: (pageWidthPt - widthPt) / 2,
        yPt: 0,
        widthPt,
        heightPt
    };
};
/**
 * Builds a PDF 1.4 document with a single page that embeds one JPEG image.
 *
 * Mirrors the output of `jsPDF.addImage(jpeg, 'JPEG', x, y, w, h)` for our specific case:
 * one page, one DCTDecode image, aspect-fit centred. PDF coordinates have origin at the
 * bottom-left, so the image translation is computed from the top of the page.
 */ export function buildSingleImagePdf(jpegBytes, pageWidthPt, pageHeightPt, imageWidthPx, imageHeightPx) {
    const fit = fitImageRectPt(imageWidthPx, imageHeightPx, pageWidthPt, pageHeightPt);
    const contentStream = `q\n${fmt(fit.widthPt)} 0 0 ${fmt(fit.heightPt)} ${fmt(fit.xPt)} ${fmt(pageHeightPt - fit.yPt - fit.heightPt)} cm\n/Im1 Do\nQ\n`;
    const contentBytes = utf8(contentStream);
    const obj1 = '1 0 obj\n<< /Type /Catalog /Pages 2 0 R >>\nendobj\n';
    const obj2 = '2 0 obj\n<< /Type /Pages /Count 1 /Kids [3 0 R] >>\nendobj\n';
    const obj3 = '3 0 obj\n<< /Type /Page /Parent 2 0 R ' + `/MediaBox [0 0 ${fmt(pageWidthPt)} ${fmt(pageHeightPt)}] ` + '/Contents 4 0 R /Resources << /XObject << /Im1 5 0 R >> >> >>\nendobj\n';
    const obj4Header = `4 0 obj\n<< /Length ${contentBytes.length} >>\nstream\n`;
    const obj4Footer = 'endstream\nendobj\n';
    const obj5Header = `5 0 obj\n<< /Type /XObject /Subtype /Image /Width ${imageWidthPx} ` + `/Height ${imageHeightPx} /ColorSpace /DeviceRGB /BitsPerComponent 8 ` + `/Filter /DCTDecode /Length ${jpegBytes.length} >>\nstream\n`;
    const obj5Footer = '\nendstream\nendobj\n';
    // 4-byte binary marker required by PDF §7.5.2 so generic tooling treats the file as binary.
    const headerText = utf8('%PDF-1.4\n%');
    const headerBinary = new Uint8Array([
        0xff,
        0xff,
        0xff,
        0xff
    ]);
    const headerNewline = utf8('\n');
    const lengthOf = (value)=>typeof value === 'string' ? utf8(value).length : value.length;
    let pos = headerText.length + headerBinary.length + headerNewline.length;
    const off1 = pos;
    pos += lengthOf(obj1);
    const off2 = pos;
    pos += lengthOf(obj2);
    const off3 = pos;
    pos += lengthOf(obj3);
    const off4 = pos;
    pos += lengthOf(obj4Header) + contentBytes.length + lengthOf(obj4Footer);
    const off5 = pos;
    pos += lengthOf(obj5Header) + jpegBytes.length + lengthOf(obj5Footer);
    const xrefStart = pos;
    const padOff = (n)=>n.toString().padStart(10, '0');
    const xref = 'xref\n0 6\n0000000000 65535 f \n' + [
        off1,
        off2,
        off3,
        off4,
        off5
    ].map((o)=>`${padOff(o)} 00000 n \n`).join('');
    const trailer = `trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n${xrefStart}\n%%EOF\n`;
    return concatBytes([
        headerText,
        headerBinary,
        headerNewline,
        obj1,
        obj2,
        obj3,
        obj4Header,
        contentBytes,
        obj4Footer,
        obj5Header,
        jpegBytes,
        obj5Footer,
        xref,
        trailer
    ]);
}
